import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const productDocInfoApi = createApi({
    reducerPath: "productDocInfo",
    baseQuery,
    // prepareHeaders: (headers) => {
    //   const token = localStorage.getItem("userToken");
    //   if (token) headers.set("Authorization", `Bearer ${token}`);
    //   headers.set("X-Request-Id", crypto.randomUUID());
    //   return headers;
    // },
    tagTypes: ["productDocInfo"],
    endpoints: (builder) => ({
     
        createProductDocInfo: builder.mutation({
            query: ({ id,...data }) => ({
              url: `/export/product/docInfo/${id}`, 
              method: "PUT",
              headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
              body: { exportProductDOCInfo:data },
            }),
            invalidatesTags: ["productDocInfo"],
          }),

          getDocInfoDetailsById: builder.query({
            query: ({id}) => `export/product/docInfo/${id}`,
            transformResponse: (response) => 
              {
                const data= response?.data ?? [];
                const normalized = Array.isArray(data) ? data : [data];
                return normalized.map((item,index) => ({
                  ...item,
                  SrNo:index+1,
                  id: item.exportProductDOCInfoId, // 👈 use backend's exportEntityId
                }));

              },
            providesTags: ["productDocInfo"],
          }), 
  
          updateProductDocInfo: builder.mutation({
            query: ({ id,subId, ...data }) => ({
              url: `/export/product/docInfo/${id}/${subId}`,
              method: "PUT",
              headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
              body: { exportProductDOCInfo:data },
            }),
            invalidatesTags: ["productDocInfo"],
          }),

      
          deleteProductDocInfo: builder.mutation({
            query: ({ id}) => ({
              url: `export/product/docInfo/${id}`,
              method: "DELETE",
              headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
            }),
            invalidatesTags: ["productDocInfo"],
          }),
         
        






      }), 
    }); 

    export const {
      useCreateProductDocInfoMutation, 
      useLazyGetDocInfoDetailsByIdQuery, 
      useUpdateProductDocInfoMutation,
      useDeleteProductDocInfoMutation
      

      } = productDocInfoApi;
